import { render, staticRenderFns } from "./AppointTime.vue?vue&type=template&id=285ecc96&scoped=true&"
import script from "./AppointTime.vue?vue&type=script&lang=js&"
export * from "./AppointTime.vue?vue&type=script&lang=js&"
import style0 from "./AppointTime.vue?vue&type=style&index=0&id=285ecc96&lang=less&scoped=true&"
import style1 from "./AppointTime.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285ecc96",
  null
  
)

export default component.exports